import axios from "axios";

export default {
    async getCustomers(userType: string, userID: string) {
        const data = new FormData();
        data.append("depth", "2");

        if (userType && userType === "5") {
            data.append("where[]", `(customers_sales_agent = '${userID}')`);
        }

        const response = await axios.post("rest/v1/search/customers", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });

        return response.data;
    },
};
